export default __webpack_public_path__ + "static/media/Logo-light-bkg.5ec5aee4.svg";